import { render, staticRenderFns } from "./settingCompetitionAssistant.vue?vue&type=template&id=a82fd85a&scoped=true"
import script from "./settingCompetitionAssistant.vue?vue&type=script&lang=ts"
export * from "./settingCompetitionAssistant.vue?vue&type=script&lang=ts"
import style0 from "./settingCompetitionAssistant.vue?vue&type=style&index=0&id=a82fd85a&prod&scoped=true&lang=stylus"
import style1 from "./settingCompetitionAssistant.vue?vue&type=style&index=1&id=a82fd85a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82fd85a",
  null
  
)

export default component.exports